import React from 'react';
import '../components-css/ImgBienvenido.css';

const ImgBienvenido = () => (
  <section className="main-slider">
    <div
      className="image-layer"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/backgrounds/Header%202.png)`
      }}
    ></div>
  </section>
);

export default ImgBienvenido;